export default __webpack_public_path__ + "static/media/tempoApiIntegration.ef85ba4c.png";